<template>
  <div class="gerenzx">

      <!-- tab切换 -->
      <div class="gerenzx-tab">
          <div class="gerenzx-tab-one">
              <span class="ac"  :class="{gerentabstab:shows==1}" @click="toggleTab('gerenzxtwo'),awshow()">我的创作</span>
          </div>
          <div class="gerenzx-tab-one">
              <span  class="a" :class="{gerentabstab:shows==2}" @click="bwshow()">作品审核</span>
          </div>
          <div class="gerenzx-tab-one">
              <span class="a"  :class="{gerentabstab:shows==3}" @click="toggleTab('gerenxinxi'),cwshow()">账户信息</span>
          </div>
          <div class="gerenzx-tab-one">
              <span  class="a"  :class="{gerentabstab:shows==4}" @click="dwshow()">认证信息</span>
          </div>
      </div>
       
      <!-- 组件切换 -->
      <gerenzxtwo :is="currentView"></gerenzxtwo>
     
  </div>
</template>

<script>
import GeRenzx from '../css/GeRenzx.css'
import gerenzxtwo from './GeRenzxtwo'
import gerenzxthree from './GeRenzxthree'
import gerenxinxi from './GeRenxinxi'
export default {
 data(){
     return{ 
         gerenzx:['我的创作','作品审核','账户信息','认证信息'],
         currentView:'gerenzxtwo',
         shows:''
     }
 },
 methods:{
    //  组件切换
toggleTab(tab){
    this.currentView= tab;
},
awshow(){
this.shows =1;

},
bwshow(){
this.shows =2;
},
cwshow(){
this.shows =3;
},
dwshow(){
this.shows =4;
}
},
components:{
gerenxinxi,
gerenzxtwo
},

}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/GeRenzx.vue